<template>
  <div
    v-if="getErros.length > 0"
    class="notice d-flex flex-column bg-light-danger rounded border-danger border border-dashed p-6"
  >
    <div class="row">
      <div class="d-flex flex-row align-items-center mb-4">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
      </div>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <div class="fs-6 text-gray-600">
            <ul>
              <li v-for="value in getErros" :key="value">
                <button
                  class="btn btn-link p-0"
                  v-if="value.error"
                  @click="localizarCampo(value.elemento)"
                >
                  {{ value.error }}
                </button>
                <a v-else>
                  {{ value }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"
      >
        <div class="dataTables_length" id="kt_erros_table_length">
          <label
            ><select
              name="kt_erros_table_length"
              class="form-select form-select-sm form-select-solid"
              @change="setItemsPerPageErros"
              v-model="rowsPageErros"
            >
              <option
                v-for="pageSize in pageSizes"
                v-bind:key="pageSize"
                v-bind:value="pageSize"
              >
                {{ pageSize }}
              </option>
            </select></label
          >
        </div>
      </div>
      <div
        class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end"
      >
        <el-pagination
          v-model:current-page="paginationErros.page"
          @current-change="currentPageChangeErros"
          :page-size="paginationErros.rowsPerPage"
          layout="prev, pager, next"
          :total="this.errosValidacaoGeral.length"
          :hide-on-single-page="true"
          background
        >
        </el-pagination>
      </div>
    </div>
  </div>
  <div class="dataTables_wrapper dt-bootstrap4 no-footer mt-4">
    <div class="table-responsive mb-5">
      <table
        :class="[isloading && 'overlay overlay-block']"
        class="table align-middle table-row-dashed fs-6 gs-3 dataTable no-footer border-bottom border-start border-end table-rounded pe-1 mb-5"
        id="kt_custom_table_conversao"
        ref="kt_custom_table_conversao"
        role="grid"
      >
        <thead class="table-secondary">
          <tr
            class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0"
            role="row"
          >
            <th
              @click="this.sort(header.key)"
              :class="[
                this.sortable !== false && 'sorting',
                this.currentSort === `${header.key} desc` && 'sorting_desc',
                this.currentSort === `${header.key} asc` && 'sorting_asc',
              ]"
              tabindex="0"
              rowspan="1"
              colspan="1"
              style="cursor: pointer"
              class="fw-bold w-auto"
              v-for="(header, index) in getHeaders()"
              :key="index"
            >
              {{ header.descricao }}
            </th>
            <th
              rowspan="1"
              colspan="1"
              style="cursor: pointer"
              class="fw-bold w-auto"
            >
              {{ "AÇÕES" }}
            </th>
          </tr>
        </thead>
        <tbody class="fw-bold text-gray-600 h-auto">
          <template v-if="getItems.length > 0">
            <template v-for="(item, index) in getItems" :key="index">
              <tr>
                <td
                  class="w-auto"
                  :class="[this.enableEdicao && `p-0`]"
                  v-for="(header, indexHeader) in getHeaders()"
                  :key="indexHeader"
                  :data-title="header.descricao"
                >
                  <div
                    class="w-auto"
                    v-if="this.retornaTipoCampo(header.key) === `datetime-utc`"
                  >
                    <div v-if="enableEdicao">
                      <FocusTextInput
                        :id="getId(item.guid, header.key)"
                        class="min-w-200px"
                        v-model="item[header.key]"
                        v-on:keyup.enter="
                          verificarProximoCampo(index, indexHeader)
                        "
                        :type="`date`"
                        :hasError="
                          getErrorByID(item.guid, header.key) ? true : false
                        "
                        @isFocus="
                          this.isFocus[getId(item.guid, header.key)] = $event
                        "
                      >
                      </FocusTextInput>
                      <div
                        v-if="
                          this.isFocus[getId(item.guid, header.key)] &&
                          getErrorByID(item.guid, header.key)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(item.guid, header.key) }}
                      </div>
                    </div>
                    <div v-else>
                      {{
                        this.$utils.formatarDataHoraFusoHorario(
                          item[header.key]
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="w-auto"
                    v-else-if="this.retornaTipoCampo(header.key) === `datetime`"
                  >
                    <div v-if="enableEdicao">
                      <FocusTextInput
                        :id="getId(item.guid, header.key)"
                        class="min-w-200px"
                        v-model="item[header.key]"
                        v-on:keyup.enter="
                          verificarProximoCampo(index, indexHeader)
                        "
                        :type="`date`"
                        :hasError="
                          getErrorByID(item.guid, header.key) ? true : false
                        "
                        @isFocus="
                          this.isFocus[getId(item.guid, header.key)] = $event
                        "
                      >
                      </FocusTextInput>
                      <div
                        v-if="
                          this.isFocus[getId(item.guid, header.key)] &&
                          getErrorByID(item.guid, header.key)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(item.guid, header.key) }}
                      </div>
                    </div>
                    <div v-else>
                      {{ this.$utils.formatarDataHora(item[header.key]) }}
                    </div>
                  </div>
                  <div
                    v-else-if="this.retornaTipoCampo(header.key) === `number`"
                  >
                    <div v-if="enableEdicao">
                      <FocusCurrencyInput
                        :id="getId(item.guid, header.key)"
                        v-model="item[header.key]"
                        :options="optionsInteger"
                        class="min-w-100px"
                        style="text-align: center"
                        v-on:keyup.enter="
                          verificarProximoCampo(index, indexHeader)
                        "
                        :hasError="
                          getErrorByID(item.guid, header.key) ? true : false
                        "
                        @isFocus="
                          this.isFocus[getId(item.guid, header.key)] = $event
                        "
                      ></FocusCurrencyInput>
                      <div
                        v-if="
                          this.isFocus[getId(item.guid, header.key)] &&
                          getErrorByID(item.guid, header.key)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(item.guid, header.key) }}
                      </div>
                    </div>
                    <div v-else>
                      {{ item[header.key] }}
                    </div>
                  </div>
                  <div
                    v-else-if="this.retornaTipoCampo(header.key) === `decimal`"
                  >
                    <div v-if="enableEdicao">
                      <FocusCurrencyInput
                        :id="getId(item.guid, header.key)"
                        v-model="item[header.key]"
                        :options="options"
                        class="min-w-100px"
                        style="text-align: center"
                        v-on:keyup.enter="
                          verificarProximoCampo(index, indexHeader)
                        "
                        :hasError="
                          getErrorByID(item.guid, header.key) ? true : false
                        "
                        @isFocus="
                          this.isFocus[getId(item.guid, header.key)] = $event
                        "
                      ></FocusCurrencyInput>
                      <div
                        v-if="
                          this.isFocus[getId(item.guid, header.key)] &&
                          getErrorByID(item.guid, header.key)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(item.guid, header.key) }}
                      </div>
                    </div>
                    <div v-else>
                      {{ this.$utils.formatarNumero(item[header.key]) }}
                    </div>
                  </div>
                  <div class="text-nowrap w-auto" v-else>
                    <div v-if="enableEdicao">
                      <FocusTextInput
                        :id="getId(item.guid, header.key)"
                        class="min-w-200px"
                        v-model="item[header.key]"
                        v-on:keyup.enter="
                          verificarProximoCampo(index, indexHeader)
                        "
                        :hasError="
                          getErrorByID(item.guid, header.key) ? true : false
                        "
                        @isFocus="
                          this.isFocus[getId(item.guid, header.key)] = $event
                        "
                      >
                      </FocusTextInput>
                      <div
                        v-if="
                          this.isFocus[getId(item.guid, header.key)] &&
                          getErrorByID(item.guid, header.key)
                        "
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ getErrorByID(item.guid, header.key) }}
                      </div>
                    </div>
                    <div v-else>
                      {{ item[header.key] }}
                    </div>
                  </div>
                </td>
                <td class="w-auto" :class="[this.enableEdicao && `p-0`]">
                  <div class="w-auto">
                    <button
                      type="button"
                      class="btn btn-sm btn-icon btn-clear btn-active-light-danger ms-1"
                      @click="excluirRegistro(item.guid)"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/general/gen027.svg"
                      /></span>
                    </button>
                  </div>
                </td>
              </tr>
            </template>
          </template>
          <template v-else>
            <tr class="odd">
              <td :colSpan="12" class="dataTables_empty">
                {{ emptyTableText }}
              </td>
            </tr>
          </template>
        </tbody>
        <div
          v-if="isloading"
          class="overlay-layer card-rounded bg-dark bg-opacity-5"
        >
          <div class="spinner-border text-primary" role="status"></div>
          <span class="ms-2">Aguarde, carregando...</span>
        </div>
      </table>
    </div>
    <div class="row">
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"
      >
        <div
          v-if="enableItemsPerPageDropdown"
          class="dataTables_length"
          id="kt_conversao_table_length"
        >
          <label
            ><select
              name="kt_conversao_table_length"
              class="form-select form-select-sm form-select-solid"
              @change="setItemsPerPage"
              v-model="rowsPage"
            >
              <option
                v-for="pageSize in pageSizes"
                v-bind:key="pageSize"
                v-bind:value="pageSize"
              >
                {{ pageSize }}
              </option>
            </select></label
          >
        </div>
      </div>
      <div
        class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end"
      >
        <el-pagination
          v-model:current-page="pagination.page"
          @current-change="currentPageChange"
          :page-size="pagination.rowsPerPage"
          layout="prev, pager, next"
          :total="pagination.total"
          :hide-on-single-page="true"
          background
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import FocusTextInput from "@/components/text/FocusTextInput";
import FocusCurrencyInput from "@/components/text/FocusCurrencyInput";
import arraySort from "array-sort";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: "KTDatatableConversao",
  components: { FocusTextInput, FocusCurrencyInput },
  props: {
    data: { type: Array, required: true },
    model: { type: Object, required: true },
    isloading: { type: Boolean, required: false, default: false },
    emptyTableText: { type: String, default: "Nenhum dado encontrado" },
    sortable: { type: Boolean, required: false, default: false },
    orderHeaders: { type: Boolean, required: false, default: true },
    enableEdicao: { type: Boolean, required: false, default: false },
    enableItemsPerPageDropdown: { type: Boolean, default: true },
    errosValidacao: { type: Object, required: false, default: () => ({}) },
    errosValidacaoGeral: { type: Array, required: false, default: () => [] },
    pageSizes: {
      type: Array,
      required: false,
      default: () => ["10", "25", "50", "100"],
    },
    rowsPerPage: { type: Number, default: 10 },
  },
  computed: {
    getErros() {
      if (this.errosValidacaoGeral.length > 0) {
        const startFrom =
          this.paginationErros.page * this.paginationErros.rowsPerPage -
          this.paginationErros.rowsPerPage;
        const clone = JSON.parse(JSON.stringify(this.errosValidacaoGeral));
        return clone.splice(startFrom, this.paginationErros.rowsPerPage);
      } else {
        return [];
      }
    },
    getItems() {
      if (this.dados.length > 0) {
        const startFrom =
          this.pagination.page * this.pagination.rowsPerPage -
          this.pagination.rowsPerPage;
        if (this.enableEdicao === true) {
          const endTo = startFrom + this.pagination.rowsPerPage;
          return this.dados.slice(startFrom, endTo);
        } else {
          const clone = JSON.parse(JSON.stringify(this.dados));
          return clone.splice(startFrom, this.pagination.rowsPerPage);
        }
      } else {
        return [];
      }
    },
    getId() {
      return (chave, campo) => {
        if (chave && campo) {
          return `dados[${chave}]${campo.replaceAll(`.`, ``)}`;
        } else {
          return "";
        }
      };
    },
    getErrorByID() {
      return (chave, campo) => {
        let id = this.getId(chave, campo);
        return this.errosValidacao[id] &&
          this.errosValidacao[id] !== undefined &&
          this.errosValidacao[id] !== ""
          ? this.errosValidacao[id]
          : null;
      };
    },
  },
  methods: {
    async showQuestionAlert(text) {
      return await Swal.fire({
        text: text,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "ENTER - Sim",
        cancelButtonText: "ESC - Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    async excluirRegistro(guid) {
      let alert = await this.showQuestionAlert("Deseja remover o registro?");
      if (alert.isConfirmed) {
        const indexToRemove = this.dados.findIndex(
          (item) => item.guid === guid
        );
        if (indexToRemove !== -1) {
          await this.dados.splice(indexToRemove, 1);

          const indexesToRemove = this.errosValidacaoGeral.reduce(
            (acc, item, index) => {
              if (item.elemento.includes(guid)) {
                acc.push(index);
              }
              return acc;
            },
            []
          );

          if (indexesToRemove.length > 0) {
            let tempErrosValidacaoGeral = this.errosValidacaoGeral;
            indexesToRemove.reverse().forEach((indexToRemove) => {
              tempErrosValidacaoGeral.splice(indexToRemove, 1);
            });
            if (this.getErros.length === 0) {
              this.paginationErros.page = 1;
            }
          }

          toast.success("Registro excluído com sucesso!", { timeout: 3000 });
        }
      }
    },
    localizarCampo(campo) {
      let regex = /\[([^\]]+)\]/;
      let resultado = regex.exec(campo);

      if (resultado) {
        const guid = resultado[1];
        const indexToFocus = this.dados.findIndex((item) => item.guid === guid);

        if (indexToFocus !== -1) {
          const page = this.calcularPagina(indexToFocus);
          this.pagination.page = page;
          setTimeout(() => {
            this.nextFocus(campo);
          }, 400);
        }
      }
    },
    calcularPagina(index) {
      return Math.floor(index / this.pagination.rowsPerPage) + 1;
    },
    retornaTipoCampo(campo) {
      const tipo = this.model[campo]
        ? this.model[campo].tipo || "unknown"
        : "unknown";

      const tipoComplementar = this.model[campo]
        ? this.model[campo].tipoComplementar || "unknown"
        : "unknown";

      if (tipo === "object" || tipo === "array") {
        return "text";
      } else if (tipo.toUpperCase().includes("INT")) {
        return "number";
      } else if (tipo.toUpperCase().includes("STRING")) {
        return "text";
      } else if (tipo.toUpperCase().includes("DATETIME")) {
        if (tipoComplementar.toUpperCase().includes("UTC")) {
          return "datetime-utc";
        } else {
          return "datetime";
        }
      } else if (tipo.toUpperCase().includes("DECIMAL")) {
        return "decimal";
      } else {
        return "text";
      }
    },
    getHeaders() {
      if (this.dados.length > 0) {
        const firstItem = this.orderHeaders
          ? this.camposOrdenados(this.dados[0])
          : this.dados[0];
        const keys = Object.keys(firstItem);

        const filteredKeys = keys
          .map((key) => {
            const value = firstItem[key];
            if (!this.isArrayOrObject(value) && this.model[key]) {
              const header =
                this.model[key] && this.model[key].descricao
                  ? this.model[key].descricao
                  : key;
              return {
                key: key,
                descricao: header,
              };
            } else {
              return "";
            }
          })
          .filter((item) => {
            return item !== "" && item !== "color";
          });

        return filteredKeys;
      }
      return [];
    },
    sort(columnName) {
      if (this.sortable === false) {
        return;
      }

      if (this.order === "asc") {
        this.order = "desc";
        arraySort(this.dados, columnName, { reverse: true });
      } else {
        this.order = "asc";
        arraySort(this.dados, columnName, { reverse: false });
      }
      this.currentSort = columnName + " " + this.order;
    },
    currentPageChange(page) {
      this.pagination.page = page;
    },
    setItemsPerPage(event) {
      if (this.$utils.isNumber(event.target.value)) {
        this.pagination.rowsPerPage = parseInt(event.target.value);
      } else {
        this.pagination.rowsPerPage = this.dados.length;
        this.rowsPage = event.target.value;
      }
      this.pagination.page = 1;
    },
    camposOrdenados(objeto) {
      const compararPorDescricao = (a, b) => {
        const descricaoA = a.toUpperCase();
        const descricaoB = b.toUpperCase();

        if (descricaoA < descricaoB) return -1;
        if (descricaoA > descricaoB) return 1;
        return 0;
      };

      const arrayDePares = Object.entries(objeto);

      arrayDePares.sort((a, b) => compararPorDescricao(a[0], b[0]));

      const objetoOrdenado = Object.fromEntries(arrayDePares);

      return objetoOrdenado;
    },
    isArrayOrObject(item) {
      if (
        item &&
        item !== null &&
        !(item instanceof Date) &&
        (item instanceof Array || typeof item === "object")
      ) {
        return true;
      } else {
        return false;
      }
    },
    verificarProximoCampo(indexItem, indexHeader) {
      let headers = this.getHeaders();
      let items = this.getItems;

      if (this.getErrorByID(items[indexItem].guid, headers[indexHeader].key)) {
        let id = this.getId(items[indexItem].guid, headers[indexHeader].key);
        delete this.errosValidacao[id];
        const indexToRemove = this.errosValidacaoGeral.findIndex(
          (item) => item.elemento === id
        );
        if (indexToRemove !== -1) {
          let tempErrosValidacaoGeral = this.errosValidacaoGeral;
          tempErrosValidacaoGeral.splice(indexToRemove, 1);
          if (this.getErros.length === 0) {
            this.paginationErros.page = 1;
          }
        }
      }

      let proxIndex = indexHeader + 1;
      if (proxIndex < headers.length) {
        this.nextFocus(
          this.getId(items[indexItem].guid, headers[proxIndex].key)
        );
      } else {
        if (items[indexItem + 1]) {
          this.nextFocus(this.getId(items[indexItem + 1].guid, headers[0].key));
        }
      }
    },
    nextFocus(id) {
      let element = document.getElementById(id);
      if (element != null) {
        element.scrollIntoView({
          behavior: "smooth",
        });
        element.focus();
      }
    },
    currentPageChangeErros(page) {
      this.paginationErros.page = page;
    },
    setItemsPerPageErros(event) {
      if (this.$utils.isNumber(event.target.value)) {
        this.paginationErros.rowsPerPage = parseInt(event.target.value);
      } else {
        this.paginationErros.rowsPerPage = this.errosValidacaoGeral.length;
        this.rowsPageErros = event.target.value;
      }
      this.paginationErros.page = 1;
    },
  },
  mounted() {
    this.dados = this.data;
    if (this.dados.length > 0) {
      this.currentSort = this.label + " " + this.order;
      this.pagination.total = this.dados.length;
      this.pagination.rowsPerPage = this.rowsPerPage;
      this.rowsPage =
        this.pagination.rowsPerPage > this.dados.length
          ? "Todos"
          : this.pagination.rowsPerPage.toString();
    }
  },
  data() {
    return {
      timeOut: null,
      dados: [],
      loading: this.isloading,
      currentSort: "",
      order: "asc",
      label: "",
      rowsPage: "10",
      pagination: {
        page: 1,
        total: 0,
        rowsPerPage: 0,
      },
      rowsPageErros: "10",
      paginationErros: {
        page: 1,
        rowsPerPage: 10,
      },
      isFocus: [],
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
      optionsInteger: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 0,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
